import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const MobileLoginBlock = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      BackdropProps={{
        style: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: 'white',
          color: 'var(--secondary-color)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '1rem' : '2rem',
          maxWidth: isMobile ? '90%' : '600px',
          maxHeight: isMobile ? '50%' : '400px',
          margin: 'auto',
          borderRadius: '12px',
        },
      }}
    >
      <DialogTitle style={{ padding: isMobile ? '8px 0' : '16px 0' }}>
        <Typography 
          variant={isMobile ? "h5" : "h4"}
          component="div" 
          align="center" 
          style={{ 
            fontWeight: 'bold',
            color: 'var(--secondary-color)',
            lineHeight: 1.2,
          }}
        >
          This platform is not available on mobile or tablet.
        </Typography>
      </DialogTitle>
      <DialogContent style={{ padding: isMobile ? '8px 0' : '16px 0' }}>
        <Typography 
          variant={isMobile ? "body2" : "body1"}
          align="center" 
          style={{ 
            marginTop: isMobile ? '0.5rem' : '1rem',
            color: 'var(--secondary-color)',
            opacity: 0.8,
            lineHeight: 1.5,
          }}
        >
          Please use a laptop or desktop to sign in. The platform is not supported on mobile or tablet devices yet.
        </Typography>
      </DialogContent>
      <DialogActions style={{ 
        marginTop: isMobile ? '1rem' : '2rem',
        padding: isMobile ? '8px 0' : '16px 0',
      }}>
        <Button
          onClick={onClose}
          variant="contained"
          size={isMobile ? "small" : "medium"}
          style={{
            backgroundColor: 'var(--primary-color)',
            color: 'white',
            padding: isMobile ? '0.25rem 1.5rem' : '0.5rem 2rem',
            borderRadius: '8px',
            fontSize: isMobile ? '0.875rem' : '1rem',
          }}
        >
          OK, I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MobileLoginBlock; 